"use strict";

exports.__esModule = true;
exports.iPhoneXMixin = void 0;
var _utils = require("../utils");
// 经验值，一般的浏览器顶部导航栏高度不会大于这个值，微信是88px
// 如果大于这个值，基本确定存在底部导航栏，此时无需适配
var threshhold = 100;

// 优化区块组件的 demo 在文档中用 iframe 展示，不影响业务代码
if (!_utils.isServer && window && window.self !== window.top) {
  threshhold += 44;
}
var iPhoneXMixin = {
  props: {
    forceAdapteiPhoneX: Boolean
  },
  data: function data() {
    return {
      isiPhoneX: false
    };
  },
  mounted: function mounted() {
    if (_utils.isServer || !_utils.isiPhoneX) return;
    this.shouldAdapt();
    window.addEventListener('resize', this.shouldAdapt);
  },
  beforeDestroy: function beforeDestroy() {
    if (_utils.isServer || !_utils.isiPhoneX) return;
    window.removeEventListener('resize', this.shouldAdapt);
  },
  methods: {
    // 大部分浏览器在滚动时会自动的收起或展开底部导航栏，此时会触发resize事件
    // 而如果存在底部导航栏，则不需要适配
    shouldAdapt: function shouldAdapt() {
      var isFullScreen = this.forceAdapteiPhoneX || window.screen.height - window.innerHeight < threshhold;
      if (this.isiPhoneX !== isFullScreen) {
        this.isiPhoneX = isFullScreen;
      }
    }
  }
};
exports.iPhoneXMixin = iPhoneXMixin;